// src/components/store/sections/hero-banner/HeroV24DiagonalarenaIndigoPulse.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV24DiagonalarenaIndigoPulse(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={24}
      archKey="diagonal_arena"
      archLabel="Diagonal Split Arena"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      {...props}
    />
  );
}
